import React from 'react'
import { Pane, Spinner, majorScale } from 'evergreen-ui'

const LoadingState = () => (
  <Pane display="flex" justifyContent="center" padding={majorScale(5)}>
    <Spinner />
  </Pane>
)

export default LoadingState
